export default {
    modalGenerateImageVariations: {
        imageAIHeader: "Creare immagini utilizzando l'AI",
        requestFailed: 'Richiesta fallita',
        describeYourImage: 'Descrivi la tua immagine',
        numberOfVariations: 'Numero di variazioni',
        chooseStyle: 'Scegli il tuo stile di immagine',
        descriptionPlaceholder: '(es) Un campo di fiori di senape in una giornata estiva con alberi di quercia',
        clear: 'Chiaro',
        generate: 'generare',
        seeAll: 'Vedi tutti',
        tryAnExample: 'Prova un esempio',
        tryAnother: 'Prova un altro',
    },
};
